module.exports = __webpack_public_path__ + "media/images/flags/ru-f760036294e1fff52a9a88663d0d7a46.svg";